import { render } from "./FormEditConfiguration.vue?vue&type=template&id=3cd1130e&scoped=true&lang=true"
import script from "./FormEditConfiguration.vue?vue&type=script&lang=js"
export * from "./FormEditConfiguration.vue?vue&type=script&lang=js"

import "./FormEditConfiguration.vue?vue&type=style&index=0&id=3cd1130e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd1130e"]])

export default __exports__